import React, { Component } from 'react';
import Tab from 'react-bootstrap/Tab';
import Row from 'react-bootstrap/Row';
import Nav from 'react-bootstrap/Nav';
import Col from 'react-bootstrap/Col';
import Divider from '@material-ui/core/Divider';

import OhlMenu from './menuOHL';
import SearchDialog from './searchDialog';
import SettingsMenu from './menuSetting';
import ThunderMenu from './menuThunderHit';
import UndergroundObjectsMenu from './menuUndergroundObjects';
import PruningMenu from './menuPruning';
//import SettingsCard from './SettingsCard2';


import SettingsIcon from '../../images/settings.svg';
import PoleBlankIcon from '../../images/poleBlank.svg';
import FlashIcon from '../../images/flashBlank.svg';
import EcoIcon from '../../images/chainsaw.svg';//'../../images/eco.svg';
import UndergroundObjectsIcon from '../../images/undergroundObject.svg';


const regionList = [
    { name: 'Beograd', code: 'BGD' },
    { name: 'Bor', code: 'BR' },
    { name: 'Kruševac', code: 'KS' },
    { name: 'Novi Sad', code: 'NS' },
    //{name: 'Obilić', code: 'OB'},
    //{name: 'Užice', code: 'UE'},
    { name: 'Valjevo', code: 'VA' },
    { name: 'Between Regions', code: 'BET' },
    { name: 'Interconectiv', code: 'INTER' },
]


export class MainMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filterText: '',
            selected: 'OHL Search'
        }
    }


    shouldComponentUpdate(nextProps, nextState) {
        if (!this.compareLists(this.props.ohlList, nextProps.ohlList)
            //|| !this.compareLists(this.props.checkedOhlsList, nextProps.checkedOhlsList) 
            || this.props.parentChecked !== nextProps.parentChecked
            || this.areMenuItemsChanged(this.props.menuItems, nextProps.menuItems)
            || !this.compareLists(this.props.thunderStrikesList, nextProps.thunderStrikesList)
            || this.props.simulateThunderStorm !== nextProps.simulateThunderStorm
            || this.props.checkAll !== nextProps.checkAll 
            || this.state !== nextState) {
            return true;
        }
        else {
            return false;
        }
    }

    compareLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if (list1.length !== list2.length) {
            return false;
        }
        return true;
    }


    areMenuItemsChanged = (menuItems1, menuItems2) => {
        
        for(let i = 0; i < menuItems1.length; i++){
            const item = menuItems1[i];
            const item2 = menuItems2.find(mi2 => mi2.name === item.name);
            if(!item2 || item.value !== item2.value){
                return true;
            }
        }

        return false;
    }


    filterChange = (e) => {
        setTimeout(2000);
        this.setState({
            filterText: e.target.value
        });
    }

    setSelected = (selectedTab) => {
        this.setState({
            selected: selectedTab
        })
    }

    render() {

        return (
            <span>
                <h4 style={{ marginLeft: '10px', marginBottom: '10px' }}>{this.state.selected}</h4>
                <Divider style={{ marginLeft: '10px', marginBottom: '10px' }} />
                <Tab.Container id="left-tabs-example" defaultActiveKey="ohl">
                    <Row>
                        <Col sm={2}>
                            <Nav variant="pills" className="flex-column">
                                <Nav.Item onClick={() => this.setSelected('OHL Search')}>
                                    <Nav.Link eventKey="ohl">
                                        <img src={PoleBlankIcon} alt="Smiley face" height="30" width="30" title='OHL search' />
                                    </Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item>
                                <Nav.Link eventKey="stations">
                                    <img src={SettingsIcon} alt="Smiley face" height="30" width="30"/>
                                </Nav.Link>
                            </Nav.Item> */}
                                {this.props.showOutageLayer ? <Nav.Item onClick={() => this.setSelected('OHL Outages')}>
                                    <Nav.Link eventKey="outage">
                                        <img src={FlashIcon} alt="Lightning strikes list" height="30" width="30" title='Thunder strikes list' />
                                    </Nav.Link>
                                </Nav.Item> : null}
                                {this.props.showPruningLayer ? <Nav.Item>
                                    <Nav.Link eventKey="pruning" onClick={() => this.setSelected('Pruning List')}>
                                        <img src={EcoIcon} alt="Pruning list" height="30" width="30" title='Pruning list' />
                                    </Nav.Link>
                                </Nav.Item> : null}
                                {this.props.showUndergrounObjectsLayer ? <Nav.Item onClick={() => this.setSelected('Underground Objects')}>
                                    <Nav.Link eventKey="undergroundObjects">
                                        <img src={UndergroundObjectsIcon} alt="UndergroundObjects" height="30" width="30" title='Underground objects list' />
                                    </Nav.Link>
                                </Nav.Item> : null}
                                <Nav.Item onClick={() => this.setSelected('Map Settings')}>
                                    <Nav.Link eventKey="settings" >
                                        <img src={SettingsIcon} alt="Map settings" height="30" width="30" title='Map settings' />
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col sm={10}>
                            <Tab.Content>
                                <Tab.Pane eventKey="ohl">
                                    <span>
                                        <SearchDialog
                                            filterChange={this.filterChange}
                                            filterText={this.state.filterText}
                                            checkAll={this.props.checkAll}
                                            onToogleCheckAll={this.props.onToogleCheckAll}
                                            focusAllOHLs={this.props.focusAllOHLs}
                                        />
                                        <OhlMenu
                                            ////region -> regionCode
                                            ////
                                            regionList={regionList}
                                            ohlList={this.props.ohlList}
                                            filterText={this.state.filterText}
                                            onToogleOhlChecked={this.props.onToogleOhlChecked}
                                            onToogleOhlsChecked={this.props.onToogleOhlsChecked}
                                            onToogleCheckAll={this.props.onToogleCheckAll}
                                            centerOHLByName={this.props.centerOHLByName}
                                            //centerOHLById={this.props.centerOHLById}
                                            parentChecked={this.props.checkAll}
                                            isSelectable={true}
                                        />
                                    </span>
                                </Tab.Pane>
                                <Tab.Pane eventKey="stations">
                                    <div>stanice</div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="outage">
                                    <ThunderMenu
                                        //{...this.props}
                                        toogleStateAction={this.props.toogleStateAction}
                                        onOutageHitClick={this.props.onOutageHitClick}
                                        onOhlThunderHitClick={this.props.onOhlThunderHitClick}
                                        simulateThunderStorm={this.props.simulateThunderStorm}
                                        toogleSimulateThunderStorm={this.props.toogleSimulateThunderStorm}
                                        ohlThunderStrikesList={this.props.ohlThunderStrikesList}
                                        thunderStrikesList={this.props.thunderStrikesList}

                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey="undergroundObjects">
                                    <UndergroundObjectsMenu
                                        undergroundObjectsList={this.props.undergroundObjectsList}
                                        onUndergroundObjectClick={this.props.onUndergroundObjectClick}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey="pruning">
                                <PruningMenu
                                        pruningList={this.props.pruningList}
                                        onPruningClick={this.props.onPruningClick}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey="settings">
                                    <SettingsMenu
                                        {...this.props}
                                        toogleStateAction={this.props.toogleStateAction}
                                        menuItems={this.props.menuItems}
                                        cardList={this.props.cardList}
                                    />
                                    {/* <SettingsCard /> */}
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </span>
        )
    }
}


export default MainMenu;

